"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import AppHead from "./components/AppHead.vue";
let AppMy = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.myApps = new Array();
    this.myAppsLoading = false;
    this.isAdmin = false;
    this.imgurl = "../../assets/img/app-empty.png";
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.checkAccount();
      yield this.getApps();
    });
  }
  checkAccount() {
    return __async(this, null, function* () {
      try {
        if (this.$session.type === "account") {
          this.isAdmin = true;
        }
        if (this.$session.type === "user") {
          this.isAdmin = false;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goAPP() {
    this.$router.push("/app");
  }
  getApps() {
    return __async(this, null, function* () {
      try {
        this.myAppsLoading = true;
        const response = yield API.get("api://base.apps.auth/v1/personal/apps");
        this.myApps = response.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.myAppsLoading = false;
      }
    });
  }
  jump(url, isNew = false) {
    return __async(this, null, function* () {
      if (url === "" || url === null || url === void 0) {
        return;
      }
      if (isNew) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    });
  }
};
AppMy = __decorateClass([
  Component({
    components: {
      AppHead,
      AccountSessionMixins
    }
  })
], AppMy);
export {
  AppMy as default
};
